export default "__VITE_ASSET__B1h4Es2U__"